import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { RequestService } from '../../../core/services/request.service';
import { ConfigService } from '../../../core/services/config.service';
import * as CryptoJS from 'crypto-js';
import * as sha256 from 'js-sha256';


declare var Evaporate: any;

@Injectable()
export class UploaderService {

    private evaporate: any;

    constructor(
        private requestService: RequestService,
        private configService: ConfigService
    ) {}

    storeFileDetails(file: File, component: string, bucket: string): Observable<any> {
        let url = this.configService.get('server').sahara + this.configService.get('endpoints').sahara.upload.storeFileDetails;
        let body = {
            component: component,
            name: file.name,
            type: file.type,
            size: file.size,
            url: this.configService.get('aws').url,
            bucket: bucket
        };
        return this.requestService.post(url, body);
    }

    uploadContent(content: File, name: string, bucket: string): Observable<any> {
        return Observable.create((observer: any) => {
            let signerUrl: string = this.configService.get('server').sahara + this.configService.get('endpoints').sahara.upload.signature;

            let output = {
                completed: false,
                progress: 0,
                error: null,
                url: null,
                key: null,
                bucket: null
            };
            
            this.evaporate = new Evaporate({
                signerUrl,
                awsSignatureVersion: "4",
                awsRegion: this.configService.get('aws').region,
                aws_key: this.configService.get('aws').key,
                bucket: bucket,
                computeContentMd5: true,
                cryptoMd5Method: function(data) {
                    return CryptoJS.MD5(CryptoJS.lib.WordArray.create(data)).toString(CryptoJS.enc.Base64)
                },
                cryptoHexEncodedHash256: sha256
            });
            this.evaporate.add({
                name: name,
                file: content,
                started: function(uploadId) {
                    observer.next(output);
                },
                complete: function(r) {
                    output.completed = true;
                    output.url = r.responseURL;
                    try {
                        let xmlDoc = new DOMParser().parseFromString(r.response, 'text/xml');
                        output.bucket = xmlDoc.getElementsByTagName('Bucket')[0].childNodes[0].nodeValue;
                        output.key = xmlDoc.getElementsByTagName('Key')[0].childNodes[0].nodeValue;
                    } catch(e) {
                        output.error = 'sahara.error.parsing.s3.xml'
                    }
                    observer.next(output);
                    observer.complete();
                },
                progress: function(progress: number) {
                    output.progress = Math.floor(progress * 100);
                    observer.next(output);
                },
                error: function(error: string) {
                    output.error = error;
                    observer.next(output);
                    observer.complete();
                }
            });
        });
    }

    completeFileDetails(id: string, componentId: string) {
        let url = this.configService.get('server').sahara + this.configService.get('endpoints').sahara.upload.complete;
        let body = {
            id: id,
            componentId: componentId
        };
        return this.requestService.post(url, body);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/uploader/uploader.service.ts